import React from 'react'

import { TradingItemStyled, TradingItemIconStyled, TradingItemTitleStyled, TradingItemDescStyled } from './styles'
import { TradingItemProps } from './types'

import ImageStatic from './../../atoms/ImageStatic'

const TradingItem: React.FC<TradingItemProps> = ({ title, code, icon, content }) => {
  return (
    <TradingItemStyled>
      <TradingItemIconStyled>
        <ImageStatic image={icon} />
      </TradingItemIconStyled>
      <TradingItemTitleStyled
        as="p"
        sx={{
          variant: 'bodyMontserrat6'
        }}
      >
        {title} {code && `(${code})`}
      </TradingItemTitleStyled>
      <TradingItemDescStyled
        as="p"
        sx={{
          variant: 'bodyMontserrat6'
        }}
      >
        {content}
      </TradingItemDescStyled>
    </TradingItemStyled>
  )
}

export default TradingItem
